import React from "react";
import {
    Box,
    Container,
    Typography,
    useMediaQuery,
    Card,
    CardContent,
    Paper,
    Button,
    FormHelperText,
} from "@material-ui/core";
import Header from "../../component/Header/Header";
import { useTranslation } from "react-i18next";
import PortalNavbar from "../../component/PortalNavbar/PortalNavbar";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
// import "./LoginPage.scss";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import IAMSmart_icon from "../../images/IAMSmart_icon.jpg";
import { useForm } from "react-hook-form";
import ErrorMsg from "../ErrorMsg/ErrorMsg";

const useStyles = makeStyles({
    root: {
        width: "85%",
        height: "100%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
});

export default function LoginBox({ onLogin }) {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");

    const { register, handleSubmit, watch, formState } = useForm({
        defaultValues: {
            email: "",
            password: "",
        },
        mode: "onBlur",
    });

    const onSubmit = (data) => {
        console.log("login data: ", data);
        onLogin();
    };

    const errors = formState.errors;
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Box
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    height: "100%",
                    width: "200px",
                }}
            >
                <Typography variant="h5">
                    {t("common.portal.publicLogin")}
                    <br />
                    <br />
                </Typography>
                <CustomTextField
                    label={t("common.email")}
                    required={false}
                    style={{ width: "35%" }}
                    inputProps={register("email", {
                        validate: {
                            valid: (value) =>
                                value.includes("@") || "請輸入有效的電郵。",
                        },
                        required: "電郵不能為空。",
                    })}
                    // type="email"
                />
                <FormHelperText>
                    <ErrorMsg message={errors?.email?.message} />
                </FormHelperText>
                <CustomTextField
                    label={t("common.portal.password")}
                    required={false}
                    style={{ width: "35%" }}
                    type="password"
                    inputProps={register("password", {
                        validate: {
                            valid: (value) =>
                                value == "abcd1234" ||
                                t("common.iamsmart.linkup.alreadyLinked"),
                        },
                    })}
                />
                <FormHelperText>
                    <ErrorMsg message={errors?.password?.message} />
                </FormHelperText>
                <Box>
                    <Button
                        className="buttons"
                        variant="contained"
                        color="primary"
                        style={{ marginRight: "10px" }}
                        type="submit"
                    >
                        {t("common.sideNavList.login")}
                    </Button>
                </Box>
            </Box>
        </form>
    );
}
